module.exports = "<label class=\"mui-group-item mui-group-item-radio-circle mui-check-label\" for=radio-{{uuid}}> <div class=mui-group-item-hd> <input type=radio class=mui-radio-circle id=radio-{{uuid}} :value=optionValue v-model=value :disabled=disabled> <span class=weui-icon-radio-circle></span> </div> <div class=\"mui-group-item-bd mui-group-item-primary\"> <slot> <p>{{ optionText }}</p> <inline-desc v-if=option.inlineDesc>{{ optionInlineDesc }}</inline-desc> </slot> </div> <div class=mui-group-item-ft> <slot name=ft> </slot> </div> </label>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/radio-option-circle/index.vue
 ** module id = 173
 ** module chunks = 0
 **/